export enum IDestination {
  Porec = "Poreč",
  Rab = "Otok Rab",
  Makarska = "Makarska",
  Rabac = "Rabac",
  Dubrovnik = "Dubrovnik",
  Hvar = "Otok Hvar",
  Krk = "Otok Krk",
  Obertauern = "Obertauern, Austrija",
}
